<template>
  <div>
    <el-button-group v-if="!isViewDisabled">
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-edit"
        @click="add()"
        class="mb-2"
      >{{$l('form_add_btn')||'新增'}}</el-button>
    </el-button-group>
    <!-- 表格-->
    <el-table :data="tableData" stripe
              size="small"
              :height="height"
              style="width: 100%"
              :header-cell-style="{background:'#eef1f6',color:'#606266'}"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="scmPerson"
        :label="$l('visit_table_label_manufacturer')||'厂商人员'"
        min-width="150">
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="visitPerson"
        :label="$l('visit_table_label_interviewees')||'拜访对象'"
        min-width="150">
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        prop="visitTitle"
        :label="$l('visit_table_label_purpose')||'拜访目的'"
        min-width="150">
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        prop="visitDescription"
        :label="$l('visit_table_label_visit_detail')||'拜访详情'" min-width="300">
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="visitDate"
        :label="$l('visit_table_label_visit_time')||'拜访日期'"
        min-width="150">
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        prop="scmVisitStatusText"
        :label="$l('visit_table_label_status')||'是否有效'"
        width="150"
      >
        <template slot-scope="scope">
          <el-tag
            size="mini"
            :type="scope.row.scmVisitStatusText === '有效' ? 'success' : 'danger'"
          >{{scope.row.scmVisitStatusText}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        :label="$l('table_label_operation')||'操作'"
        min-width="120"
        align="center"
        fixed="right"
        v-if="!isViewDisabled">
        <template slot-scope="scope">
          <el-button
            size="mini"
            style="padding:5px;"
            icon="el-icon-edit-outline"

            @click="update(scope.row)"
          ></el-button>
          <el-button
            size="mini"
            style="padding:5px;"
            type="danger"
            :disabled="scope.row.scmVisitStatus === 'N'"

            @click="delRow(scope.row)"
            icon="el-icon-delete"
          ></el-button>
        </template>
      </el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png"/>
          <p class="no-data">{{$l('INDEX.tips_no_data') || '暂无数据！'}}</p>
        </div>
      </div>
    </el-table>
    <!--分页-->
    <template>
      <el-pagination
        background
        :current-page="params.curPage"
        :page-size="params.pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="currentChange"
        layout="total, sizes, prev, pager, next, jumper, ->, slot">
      </el-pagination>
    </template>
    <el-dialog
      @opened="dialogOpened"
      @closed="dialogClosed"
      :title="dialogTitle"
      :visible.sync="dialogVisible1"
      width="60%">
      <VisitDetail ref="visitDetail" @back="back" @getData="getData"></VisitDetail>
    </el-dialog>
  </div>
</template>
<script>
import VisitDetail from './detail/visitDetail'
export default {
  props: {
      height: {
          default: 350,
          type: Number
      }
  },
  components: {
    VisitDetail
  },
  data () {
    return {
      dialogVisible1: false,
      isViewDisabled: false,
      tableData: [],
      formData: {},
      dialogTitle: '',
      params: {
        curPage: 1,
        pageSize: 10,
        scmCode: ''
      },
      total: 0,
      type: ''
    }
  },
  methods: {
    init (scmCode, isViewDisabled) {
      this.params.scmCode = scmCode
      this.isViewDisabled = isViewDisabled
      this.getData()
    },
    reset () {
      this.dialogVisible1 = false
      this.isViewDisabled = false
      this.tableData = []
      this.formData = {}
      this.params = {
        curPage: 1,
        pageSize: 10,
        scmCode: ''
      }
      this.getData()
    },
    getData () {
      this.$api.scmInfoVisitListApi(this.params).then(res => {
        this.total = res.body.count
        this.params.curPage = res.body.curPage
        this.params.pageSize = res.body.pageSize
        this.tableData = res.body.data
      })
    },
    dialogOpened () {
      this.$refs.visitDetail.init(this.formData)
    },
    dialogClosed () {
      this.getData()
    },
    update (row) {
      this.formData = row
      this.dialogTitle = '拜访记录修改'
      this.formData.type = 'edit'
      this.dialogVisible1 = true
    },
    add () {
      this.formData = {
        type: 'add',
        scmCode: this.params.scmCode
      }
      this.dialogTitle = '拜访记录新增'
      this.dialogVisible1 = true
    },
    delRow (row) {
      this.$confirm('是否删除？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(_ => {
          this.formData = {
            scmVisitStatus: 'N',
            visitCode: row.visitCode
          }
          this.$api.scmInfoVisitSaveApi(this.formData)
            .then(() => {
              this.$message({
                showClose: true,
                message: '删除成功',
                type: 'success'
              })
              this.getData()
            })
        })
    },
    back () {
      this.dialogVisible1 = false
    },
    sizeChange (val) {
      this.params.curPage = 1
      this.params.pageSize = val
      this.getData()
    },
    currentChange (val) {
      this.params.curPage = val
      this.getData()
    }
  }
}
</script>
